import { type PartnerTreeNodeV2 } from '@sr/types';
import { useLocations } from '../Locations/useLocations';
import { useFlag } from './useFlag';
import { useHasRnpAccess } from './useHasRnpAccess';
import { useHasExtendedRnpSiteAccess } from './useHasRnpSiteAccess';

type UseRnpAccessParams = {
  businessPartners?: string[];
  legacyPilotLocations?: PartnerTreeNodeV2[];
};

export const useRnpAccess = ({
  businessPartners,
  legacyPilotLocations,
}: UseRnpAccessParams = {}) => {
  const rnpNewAccessRoleFlag = useFlag('rnp-new-access-role');
  const extendedRnpSiteAccessFlag = useFlag('rnp-extended-site-access');
  const hasRnpAccess = useHasRnpAccess(businessPartners);
  const rnpRoleLocations = useLocations({ filterRnpRoleAccess: true });

  const pilotLocations = rnpNewAccessRoleFlag
    ? rnpRoleLocations.partnerTrees
    : (legacyPilotLocations ?? []);

  const { hasRNPExtendedAccess, selectedLocationHasExtendedRnpAccess } =
    useHasExtendedRnpSiteAccess({
      locations: pilotLocations,
      selectedLocations: businessPartners,
    });

  const hasPilotAccess = businessPartners
    ? selectedLocationHasExtendedRnpAccess
    : hasRNPExtendedAccess;

  return hasRnpAccess || (extendedRnpSiteAccessFlag && hasPilotAccess);
};
